import { Injectable } from '@angular/core';
import { IStateProvinceService } from './istate-province.service';
import { StateProvince } from './state-province.model';
import { ApiService, ApiCacheOptions } from '../../../shared/index';

@Injectable({ providedIn: 'root' })
export class StateProvinceService implements IStateProvinceService {
  public _apiService: ApiService;
  public usStatesAndCanadianProvinces: Array<StateProvince>;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getUsStatesAndCanadianProvinces(): Promise<Array<StateProvince>> {
    return this._apiService.get('Config/States', this._cacheOptions).then((data: Array<StateProvince>) => {
      return Promise.resolve(data);
    });
  }
}
